export function openSection(
  pathArray: string[],
  openedSections: { [key: string]: boolean },
) {
  let lastSection = pathArray[0];
  const sectionsToOpen = pathArray.splice(1).map((section) => {
    const sectionToOpen = `${lastSection}/${section}`;
    lastSection = sectionToOpen;
    return sectionToOpen;
  });
  sectionsToOpen.forEach((section) => {
    openedSections[section] = true;
  });
  return openedSections;
}
